export { default } from './DialogContentText';